// @flow
import React, { PureComponent } from 'react';
import type { Element } from 'react';
import PropTypes from 'prop-types';
// Helpers
import classNames from 'classnames';
import iconStyles from 'components/Icon.scss';

/**
 *  Icon React presentational component.
 */
export class Icon extends PureComponent<*, *> {
  /**
   *  Props implementation.
   * @return {object} - prop definitions
   */
  static propTypes = {
    onClick: PropTypes.func,
    iconName: PropTypes.string,
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    extendStyle: PropTypes.string,
    size: PropTypes.string,
    viewBox: PropTypes.string
  };

  /**
   * Implements defaultProps().
   */
  static defaultProps: { size: string, viewBox: string } = {
    size: 'default',
    viewBox: '0 0 32 32' // This value matches viewBox in the svg sprite file.
  };

  /**
   * Render
   * @return {ReactElement} markup
   */
  render(): Element<*> {
    const {
      iconName,
      className,
      onClick,
      size,
      viewBox,
      extendStyle
    } = this.props;

    const iconSizeClass = iconStyles[`icon-${size}`];
    return (
      <div
        className={classNames([
          iconStyles.icon,
          iconSizeClass,
          className,
          extendStyle
        ])}
      >
        <svg viewBox={viewBox} onClick={onClick}>
          <use xlinkHref={`#wci-${iconName}`} />
        </svg>
      </div>
    );
  }
}

export default Icon;



// WEBPACK FOOTER //
// ./src/Common/Icon/index.js